export const REQUEST_GETPLANNINGS_DATA = "REQUEST_GETPLANNINGS_DATA";
export const RECEIVE_GETPLANNINGS_DATA = "RECEIVE_GETPLANNINGS_DATA";

export const requestGetPlanningsData = () => ({ type: REQUEST_GETPLANNINGS_DATA });
export const receiveGetPlanningsData = data => ({ type: RECEIVE_GETPLANNINGS_DATA, data });

